import type React from 'react';

import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { Modal } from '../../../components/Modal';
import { useUserQuery } from '../../../features/user/useUserQuery';
import { useDispatchTrackEventWithLocation } from '../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import { ContactUsSuccessModal } from '../../settings/ContactUsSuccessModal/ContactUsSuccessModal';
import { useUpdatePackage } from '../../settings/PackageUpgradeBlock/useUpdatePackage';

import { StyledButton, StyledContactUsExportOption } from './styles';

export const CompanyContactUsExportOption: React.FC = () => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();
  const { data } = useUserQuery();
  const { t } = useTranslation();
  const { isHookModalOpen, setIsHookModalOpen, onOpenModalAndSendContactUsRequest } = useUpdatePackage();

  const handleClick = () => {
    dispatchTrackEventWithLocation('hooks', 'contact us', 'export data hook');
    onOpenModalAndSendContactUsRequest();
  };

  if (data?.isCrmFeatureEnabled) {
    return null;
  }

  return (
    <>
      <StyledContactUsExportOption>
        {t('company.export.contact_us')}
        <StyledButton variant="trial" onClick={handleClick}>
          <SWReactIcons iconName="spark" size="xs" iconColor={colorsPalettes.carbon[0]} />
          {t('common.contact_us')}
        </StyledButton>
      </StyledContactUsExportOption>
      {createPortal(
        <Modal isOpen={isHookModalOpen} onClose={() => setIsHookModalOpen(false)}>
          <ContactUsSuccessModal />
        </Modal>,
        document.body
      )}
    </>
  );
};
